/**
 * Lo que todavía no existe, dicho sin disimulo.
 *
 * La alternativa —enseñar un gráfico de relleno o un contador inventado— es peor que no enseñar
 * nada: el autor se fía del número, toma una decisión con él y descubre después que no medía
 * nada. Aquí se dice qué hará la sección y qué falta para que funcione.
 */
export default function Pendiente({ titulo, hara, falta }: { titulo: string; hara: string; falta: string }) {
  return (
    <section className="carta">
      <h2>{titulo}<span className="sub">todavía no</span></h2>
      <p className="vacio">{hara}</p>
      <p className="vacio"><b>Qué falta:</b> {falta}</p>
    </section>
  );
}
